{
  "name": "gtfs-to-html",
  "version": "2.12.8",
  "private": false,
  "description": "Build human readable transit timetables as HTML, PDF or CSV from GTFS",
  "keywords": [
    "transit",
    "gtfs",
    "gtfs-realtime",
    "transportation",
    "timetables"
  ],
  "homepage": "https://gtfstohtml.com",
  "bugs": {
    "url": "https://github.com/blinktaginc/gtfs-to-html/issues"
  },
  "repository": "git://github.com/blinktaginc/gtfs-to-html",
  "license": "MIT",
  "author": "Brendan Nee <brendan@blinktag.com>",
  "contributors": [
    "Evan Siroky <evan.siroky@yahoo.com>",
    "Nathan Selikoff",
    "Aaron Antrim <aaron@trilliumtransit.com>",
    "Thomas Craig <thomas@trilliumtransit.com>",
    "Holly Kvalheim",
    "Pawajoro",
    "Andrea Mignone",
    "Evo Stamatov",
    "Sebastian Knopf"
  ],
  "type": "module",
  "main": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "files": [
    "dist",
    "docker",
    "examples",
    "scripts",
    "views/default",
    "config-sample.json"
  ],
  "bin": {
    "gtfs-to-html": "dist/bin/gtfs-to-html.js"
  },
  "scripts": {
    "build": "tsup",
    "postbuild": "node scripts/postinstall.js",
    "start": "node ./dist/app",
    "prepare": "husky && npm run build",
    "postinstall": "node scripts/postinstall.js"
  },
  "dependencies": {
    "@maplibre/maplibre-gl-geocoder": "^1.9.4",
    "@turf/helpers": "^7.3.4",
    "@turf/simplify": "^7.3.4",
    "anchorme": "^3.0.8",
    "archiver": "^7.0.1",
    "cli-table": "^0.3.11",
    "css.escape": "^1.5.1",
    "csv-stringify": "^6.7.0",
    "express": "^5.2.1",
    "gtfs": "^4.18.5",
    "gtfs-realtime-pbf-js-module": "^1.0.0",
    "js-beautify": "^1.15.4",
    "lodash-es": "^4.18.1",
    "maplibre-gl": "^5.23.0",
    "marked": "^18.0.0",
    "moment": "^2.30.1",
    "pbf": "^4.0.1",
    "pretty-error": "^4.0.0",
    "pug": "^3.0.4",
    "puppeteer": "^24.40.0",
    "sanitize-filename": "^1.6.4",
    "sanitize-html": "^2.17.2",
    "sqlstring": "^2.3.3",
    "toposort": "^2.0.2",
    "yargs": "^18.0.0",
    "yoctocolors": "^2.1.2"
  },
  "devDependencies": {
    "@types/archiver": "^7.0.0",
    "@types/cli-table": "^0.3.4",
    "@types/express": "^5.0.6",
    "@types/js-beautify": "^1.14.3",
    "@types/lodash-es": "^4.17.12",
    "@types/node": "^25",
    "@types/pug": "^2.0.10",
    "@types/sanitize-html": "^2.16.1",
    "@types/sqlstring": "^2.3.2",
    "@types/toposort": "^2.0.7",
    "@types/yargs": "^17.0.35",
    "husky": "^9.1.7",
    "lint-staged": "^16.4.0",
    "prettier": "^3.8.2",
    "tsup": "^8.5.1",
    "typescript": "^6.0.2"
  },
  "engines": {
    "node": ">= 22"
  },
  "release-it": {
    "github": {
      "release": true
    },
    "plugins": {
      "@release-it/keep-a-changelog": {
        "filename": "CHANGELOG.md"
      }
    },
    "hooks": {
      "after:bump": "npm run build"
    }
  },
  "prettier": {
    "singleQuote": true
  },
  "lint-staged": {
    "*.{js,ts,json}": "prettier --write"
  },
  "pnpm": {
    "onlyBuiltDependencies": [
      "better-sqlite3",
      "puppeteer"
    ]
  }
}
